import styled from "styled-components";

import { fontStyle } from "@pages/casino/assets/styles/mixins";

export const CasinoMostPlayedSliderContainer = styled.div`
	${({ isBackground }) =>
		isBackground &&
		`background: var(--casino-last-played-container-bg);
`}
	padding-top: 10px;
	margin-bottom: 20px;
	.swiper {
		padding-right: 40px;
		.swiper-wrapper {
			margin-left: 20px;

			@media (min-width: 1600px) {
				margin-left: 0;
			}
		}
	}

	.swiper-button-prev,
	.swiper-button-next {
		display: flex;
	}

	.swiper-button-prev,
	.swiper-button-next {
		background: linear-gradient(180deg, rgba(25, 23, 38, 0.58) 0%, rgba(5, 5, 18, 0.58) 100%);
		backdrop-filter: blur(5px);
		height: 50px;
		top: calc(50%);
		width: 50px;
		color: var(--main-secondary-text-color);
		border-radius: 25px;
	}

	.swiper-button-prev {
		left: 0;
	}

	.swiper-button-next {
		right: 0;
	}

	.swiper-button-disabled {
		display: none;
	}

	.swiper-button-next:after,
	.swiper-button-prev:after {
		font-size: 22px;

		@media (min-width: 768px) {
			font-size: 32px;
		}

		@media (min-width: 1024px) {
			font-size: 35px;
		}
	}

	.swiper-button-prev:after {
		margin-right: 3px;
	}

	.swiper-button-next:after {
		margin-left: 3px;
	}

	@media (min-width: 1024px) {
		.swiper-button-prev,
		.swiper-button-next {
			display: none;
		}

		&:hover {
			.swiper-button-prev,
			.swiper-button-next {
				display: flex;
			}

			.swiper-button-prev,
			.swiper-button-next {
				background: linear-gradient(
					180deg,
					rgba(25, 23, 38, 0.58) 0%,
					rgba(5, 5, 18, 0.58) 100%
				);
				backdrop-filter: blur(5px);
				height: calc(100% - 34px);
				top: 22px;
				width: 30px;
				color: var(--main-secondary-text-color);
				border-radius: unset;

				@media (min-width: 768px) {
					width: 40px;
				}

				@media (min-width: 1024px) {
					width: 60px;
					height: 100%;
				}
			}

			.swiper-button-prev {
				left: 0;
			}

			.swiper-button-next {
				right: 0;
			}

			.swiper-button-disabled {
				display: none;
			}

			.swiper-button-next:after,
			.swiper-button-prev:after {
				font-size: 22px;

				@media (min-width: 768px) {
					font-size: 32px;
				}

				@media (min-width: 1024px) {
					font-size: 35px;
				}
			}

			.swiper-button-prev:after {
				margin-right: 3px;
			}

			.swiper-button-next:after {
				margin-left: 3px;
			}
		}
	}
`;

export const TitleContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	margin: 0 20px 20px;
	margin-bottom: 10px;

	@media (min-width: 1600px) {
		margin: 0 50px 20px;
	}

	img {
		margin-right: 5px;
		height: 16px;

		@media (min-width: 1600px) {
			margin-right: 10px;
			height: 20px;
		}
	}

	span {
		${fontStyle}
		font-size: 12px;
		text-transform: uppercase;
	}
`;
